<div class="invalid-message" *ngIf="errorMessage">{{ errorMessage }}</div>
